import mask from 'jquery-mask-plugin';
export default function buyContactForm(){
    $("#buy-phone").mask("(00) 00000-0000");
    $("#buy-form").on('submit', function (e) {
        e.preventDefault();
        var email = $("#buy-email").val();
        var name = $("#buy-name").val();
        let phone = $("#buy-phone").val();
        let subject = $("#buy-subject").val();
        let message = $("#buy-message").val();

        let cleanPhone = phone.replace(/[_\W]+/g, "").trim();

        function isValidEmail(emailAddress) {
            var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
            return pattern.test(emailAddress);
        };

        function isValidPhone(celNumber) {
            if (celNumber.length < 1) {
                return false;
            }
            let celPattern = new RegExp(/^(\d{4,5}\-\d{4})?(\d{11})?(\(\d{2}\)?\d{9})?(\(\d{2}\)?\d{4,5}\-\d{4})?(\(\d{2}\)\s\d{9})?(\(\d{2}\)\s\d{4,5}\-\d{4})?(\(\d{2}\)\s\d{1}\s\d{4}\s\d{4})?(\d{2}\s\d{1}\s\d{4}\s\d{4})?$/i);
            return celPattern.test(celNumber);
        }

        let error = false;
        if (name == '' && !error) {
            error = true;
            $('.fail-message').html( "<div class='danger-box'>Nome precisa ser preenchido </div>" );
        }

        if (isValidEmail(email) == false  && !error) {
            error = true;
            $('.fail-message').html( "<div class='danger-box'><span>Formato inválido de email </div>" );
        }

        if (isValidPhone(cleanPhone) == false  && !error) {
            error = true;
            $('.fail-message').html( "<div class='danger-box'>Formato de telefone inválido </div>" );
        }

        if (subject == '' && !error) {
            error = true;
            $('.fail-message').html( "<div class='danger-box'>Assunto precisa ser preenchido </div>" );
        }

        if (message == '' && !error) {
            error = true;
            $('.fail-message').html( "<div class='danger-box'>Mensagem precisa ser preenchida </div>" );
        }

        var url = $(this).attr('action');

        if (!error) {
            grecaptcha.ready(function () {
                grecaptcha.execute('6LdOKt0ZAAAAABn0ttc7Cv4HgqbbsfxOPg7xDW8h', {
                  action: 'submit'
                }).then(function (token) {
                    var dataString = 'name=' + name + '&email=' + email + '&phone=' + phone + '&subject=' + subject + '&message=' + message + '&gRecaptchaResponse='+ token;
                    $.ajax({
                        type: "POST",
                        url: url,
                        headers: {
                        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                        },
                        data: dataString,
                        dataType: 'json',
                        success: function (json) {
                            if (json.status == true) {
                                $('.success-message').html( "<div><i class='fa-solid fa-circle-check'></i> <span>Seu cadastro foi realizado<br><b>com sucesso!</b></span></div>" );
                                $("#buy-email").val('');
                                $("#buy-name").val('');
                                $("#buy-phone").val('');
                                $("#buy-subject").val('');
                                $("#buy-message").val('');
                                $('.success-message').fadeIn(1000, () => {
                                    $('.success-message').delay(3000).fadeOut(500);
                                });
                                $('.fail-message').fadeOut(500);
                            } else {
                                $('.fail-message').html( `<div class='danger-box'>${json.txt} </div>` );
                                $('.fail-message').fadeIn(1000, () => {
                                    $('.fail-message').delay(3000).fadeOut(500);
                                });
                                $('.success-message').fadeOut(500);
                            }
                        }
                    });
                });
            });
        }
        else {
            $('.fail-message').fadeIn(1000, () => {
                $('.fail-message').delay(3000).fadeOut(500);
            });
            $('.success-message').fadeOut(500);
        }
        return false;
      });



      /****************** Animation *****************/
    }

